import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';

import {reaction} from 'mobx'; // eslint-disable-line no-unused-vars

//Import App Components as needed
import { CT5Colorizer } from './components/index';

//Inject Providers
@inject ('RootStore')
@observer class App extends Component {

  render() {
    return (
      <div>
        <CT5Colorizer/>
      </div>
    );
  }

}

export default App;
